<template>
  <v-container
    v-shortkey.once="['esc']"
    fluid
    tag="section"
    @shortkey="escape"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          :icon="icon"
          class="mx-auto"
          max-width="650"
          help="payment"
        >
          <template v-slot:title2>
            <div v-if="user_balance" class="text-h5 d-inline">
              <div v-if="user_balance.balance" class="d-inline mx-3">
                {{ $t('fields.flight_balance') }}:
                <p :class="balanceClass(user_balance.balance)">
                  {{ user_balance.balance | numberFormat }} {{ profile.organization.currency.name }}
                </p>
              </div>
              <v-spacer v-if="$vuetify.breakpoint.mdAndDown" />
              <div v-if="user_balance.membership" class="d-inline mx-3">
                {{ $t('fields.membership_balance') }}:
                <p :class="balanceClass(user_balance.membership)">
                  {{ user_balance.membership | numberFormat }} {{ profile.organization.currency.name }}
                </p>
              </div>
            </div>
          </template>

          <template #title>
            {{ $t('payment') }}
          </template>

          <validation-observer
            ref="form"
            v-slot="{ passes }"
          >
            <v-form
              @submit.prevent="passes(start)"
            >
              <v-container class="py-0">
                <!-- Editform -->
                <edit-form
                  :payment="edited_item"
                />

                <v-row class="pa-3">
                  <v-spacer />
                  <v-btn
                    color="cancel"
                    min-width="90"
                    class="mx-1"
                    @click="escape"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    v-shortkey.once="['f10']"
                    color="primary"
                    :disabled="(edited_item.items[0].amount + edited_item.items[1].amount) < 1"
                    min-width="90"
                    class="mx-1"
                    type="submit"
                    @shortkey="passes(start)"
                  >
                    {{ $t('payment_with_barion') }}
                  </v-btn>
                  <barion-informations />
                </v-row>
              </v-container>
            </v-form>
          </validation-observer>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'
  import BarionInformations from '@/layouts/default/infos/BarionInfo'

  export default {
    name: 'PaymentStart',
    components: {
      BarionInformations,
      EditForm: () => import('@/layouts/default/edit/Payment'),
    },
    data: function () {
      return {
        icon: '$payment',
        title: 'payment',
        edited_item: {
          provider: 'barion',
          items: [
            { name: 'balance', amount: 0, description: '', quantity: 1 },
            { name: 'membership', amount: 0, description: '', quantity: 1 },
          ],
        },
        loading: false,
        prevRoute: '',
        user_balance: null,
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    mounted () {
      this.getBalances({ id: this.profile.user_id }).then(response => {
        this.user_balance = response
        // this.fetch()
      })
    },
    methods: {
      startPayment: call('payment/start'),
      getBalances: call('user/fetchBalances'),
      async fetch () {
        // this.loading = true
        this.edited_item = {
          provider: 'barion',
          items: [
            { name: 'balance', amount: 10, description: '', quantity: 1 },
            { name: 'membership', amount: 20, description: '', quantity: 1 },
          ],
        }
        // console.log(this.edited_item)
      },
      async start () {
        await this.startPayment(
          this.edited_item,
        ).then(response => {
          this.redirect(response)
        }).catch(e => {
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      redirect (response) {
        window.location.href = response
        // this.$router. push(response)
        // console.log(response)
      },
      escape () {
        this.$router.push(this.prevRoute.path).catch(() => {})
      },
      balanceClass (value) {
        let result = 'd-inline '
        result += (value < 0 ? 'red--text' : 'green--text')
        return result
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
